import React from "react";
import { Container, Typography, Box, Link, Button } from "@mui/material";
import { useLang } from "../context/LangContext";
import locales from "../locales.json";

const Contact = () => {
  const { lang } = useLang();
  const { contact_page } = locales;
  const [phone, setPhone] = React.useState("");

  console.log(phone.length);

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: { xs: "center", md: "flex-start" }, // Centre sur mobile
        paddingTop: { xs: "32px", md: "50px" },         // Moins de padding sur mobile
        textAlign: { xs: "center", md: "left" },        // Centre sur mobile
        maxWidth: { xs: "100%", md: "800px" },          // 100% sur mobile, 800px sur desktop
        width: "100%",
        px: { xs: 2, md: 0 },                           // Padding horizontal sur mobile
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: "bold",
          marginBottom: "30px",
          fontSize: { xs: "2rem", md: "2.5rem" }, // Taille adaptée
          wordBreak: "break-word",
        }}
      >
        {contact_page.title[lang]}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          marginBottom: "20px",
          fontSize: { xs: "1rem", md: "1.1rem" },
          wordBreak: "break-word",
        }}
      >
        {contact_page.description[lang]}
      </Typography>
      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.2rem", md: "1.5rem" },
            wordBreak: "break-word",
          }}
        >
          {contact_page.help[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {contact_page.contact_text[lang]}{" "}
          <Link href="mailto:contact@medicta.ch">contact@medicta.ch</Link>
          <br />
          {contact_page.contact_text2[lang]}
          {phone.length === 0 ? (
            <Button
              color="info"
              onClick={() => {
                setPhone("079 959 39 35");
              }}
              sx={{
                mt: 1,
                fontSize: { xs: "1rem", md: "1.1rem" },
                borderRadius: "24px",
                px: 3,
                py: 1,
              }}
            >
              {contact_page.show_tel[lang]}
            </Button>
          ) : (
            <Box sx={{ mt: 1, fontWeight: "bold", fontSize: { xs: "1.1rem", md: "1.2rem" } }}>{phone}</Box>
          )}
        </Typography>
      </Box>
      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.2rem", md: "1.5rem" },
            wordBreak: "break-word",
          }}
        >
          {contact_page.address[lang]}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" }, wordBreak: "break-word" }}>
          {contact_page.company[lang]}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" }, wordBreak: "break-word" }}>
          {contact_page.name[lang]}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" }, wordBreak: "break-word" }}>
          {contact_page.address1[lang]}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" }, wordBreak: "break-word" }}>
          {contact_page.address2[lang]}
        </Typography>
      </Box>
    </Container>
  );
};

export default Contact;
